import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SeoHead from '@/components/feature/SeoHead';
import HeroSection from './components/HeroSection';
import TrustBadges from './components/TrustBadges';
import BenefitsSection from './components/BenefitsSection';
import FeatureComparison from './components/FeatureComparison';
import CategoryGrid from './components/CategoryGrid';
import CtaSection from './components/CtaSection';
import SocialProof from './components/SocialProof';
import AboutSection from './components/AboutSection';
import ArticleListSection from './components/ArticleListSection';
import FaqSection from './components/FaqSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://usfansspreadsheet.work';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'usfansspreadsheet',
    url: siteUrl,
    description: 'Kompletny przewodnik po usfansspreadsheet — porównania, bezpieczeństwo i najlepsze rozwiązania 2026',
    inLanguage: 'pl-PL',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'usfansspreadsheet',
    url: siteUrl,
    description: 'Kompletny przewodnik po usfansspreadsheet — porównania, bezpieczeństwo i najlepsze rozwiązania',
    sameAs: [
      'https://kaspreadsheet.com/',
    ],
  },
];

export default function Home() {
  return (
    <>
      <SeoHead jsonLd={homeJsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <TrustBadges />
        <BenefitsSection />
        <FeatureComparison />
        <CategoryGrid />
        <CtaSection />
        <SocialProof />
        <AboutSection />
        <ArticleListSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}